import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const ClockCircleIcon = (t0)=>{
    const $ = c(8);
    const { width, height, color } = t0;
    let t1;
    if ($[0] !== color) {
        t1 = /*#__PURE__*/ jsx("rect", {
            width: "16",
            height: "16",
            rx: "8",
            fill: color
        });
        $[0] = color;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ jsx("g", {
            clipPath: "url(#clip0_2451_4941)",
            children: /*#__PURE__*/ jsx("path", {
                d: "M8.40319 5.00005C8.40319 4.59124 8.08907 4.30005 7.70159 4.30005C7.31411 4.30005 7 4.61345 7 5.00005L7.00731 8.60104C7.04587 8.86572 7.23397 9.08917 7.49596 9.16931L10.2032 9.98944C10.5625 10.094 10.875 9.83831 10.9783 9.50229C11.0628 9.13254 10.899 8.74588 10.5132 8.62786L8.40319 7.98205V5.00005Z",
                fill: "white"
            })
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ jsx("defs", {
            children: /*#__PURE__*/ jsx("clipPath", {
                id: "clip0_2451_4941",
                children: /*#__PURE__*/ jsx("rect", {
                    width: "12",
                    height: "12",
                    fill: "white",
                    transform: "translate(2 2)"
                })
            })
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== height || $[5] !== t1 || $[6] !== width) {
        t4 = /*#__PURE__*/ jsxs("svg", {
            viewBox: "0 0 16 16",
            width: width,
            height: height,
            children: [
                t1,
                t2,
                t3
            ]
        });
        $[4] = height;
        $[5] = t1;
        $[6] = width;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
};
export { ClockCircleIcon };
